import { Backdrop, Box, Button, CircularProgress, Stack, TextField, Checkbox, Typography, MenuItem, IconButton, FormControlLabel } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Context } from '../../App';
import moment from 'moment';
import { Add, Delete } from '@mui/icons-material';

export default function ProjectForm({close, showResult, setProjects, project=null}) {
    const { setIsConnected } = React.useContext(Context);
    
    const [titre, setTitre] = useState(project?.titre || '');
    const [description, setDescription] = useState(project?.description || '');
    const [date, setDate] = useState(project?.date ? moment.utc(project.date).format('yyyy-MM-DD') : '');
    const [heure, setHeure] = useState(project?.heure || '');
    const [lieu, setLieu] = useState(project?.lieu || '');
    const [imageFile, setImage] = useState(project?.image || '');
    const [dateDebut, setDateDebut] = useState(project?.dateDebut? moment.utc(project.dateDebut).format('yyyy-MM-DD') : '');
    const [dateFin, setDateFin] = useState(project?.dateFin ? moment.utc(project.dateFin).format('yyyy-MM-DD') : '');
    const [type, setType] = useState(project?.type || '');
    const [place, setPlace] = useState(project?.place || 0);
    const [objectifBillets, setObjectifBillets] = useState(project?.objectifBillets || 0);
    const [objectifRecette, setObjectifRecette] = useState(project?.objectifRecette || 0);
    const [tarifs, setTarifs] = useState(project?.tarifs?.length>0 ? project.tarifs : [{ nom: '', montant: 0, description: '' }]);
    const [organisateur, setOrganisateur] = useState(project?.organisateur || '');
    const [canceled, setCanceled] = useState(!!project ? project.statut==='annulé' : false);
    const [isFree, setIsFree] = useState(project?.isFree || false);
    const [loading, setLoading] = useState(false);

    function handleSave(e) {
        e.preventDefault();
        setLoading(true);
        
        const newProject = {titre, description, date, heure, lieu, dateDebut, dateFin, type, organisateur, isFree,
            tarifs: isFree ? [] : tarifs,
            statut: canceled ? 'annulé' :
                moment(date).isBefore(moment(), 'D') ? 'terminé' :
                moment(dateDebut).isAfter(moment()) ? 'à venir' : 
                moment(dateFin).isBefore(moment()) ? 'fin des inscriptions' : 'en cours', 
        };
        [place, objectifBillets, objectifRecette].forEach((val, index) => {
            if (val !== 0 && val !== '') {
                if (index === 0) newProject.place = val;
                else if (index === 1) newProject.objectifBillets = val;
                else if (index === 2) newProject.objectifRecette = val;
            }
        });
        let formdata = new FormData()
        for (let key in newProject) {
            // Si c'est un tableau ou un objet, on stringify
            if (typeof newProject[key] === 'object') {
                formdata.append(key, JSON.stringify(newProject[key]));
            } else {
                formdata.append(key, newProject[key]);
            }
        }

        if(imageFile instanceof File) {
            formdata.append('imageFile', imageFile);
        }

        const url = process.env.REACT_APP_API_URL.concat(project?._id ? `/adm/events/${project._id}` : '/adm/events');
        
        fetch(url, {
            method: project?._id ? 'PATCH':'POST',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`
            },
            body: formdata
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', token);
                }
                if (response.status === 200) {
                    const json = await response.json();
                    if (json) {
                        setProjects(prev => project ? prev.map(p => p._id === project._id ? json : p) : [...prev, json]);
                    }
                    showResult(Boolean(json));
                } else {
                    showResult(false);
                }
            }
        }).catch(error => {
            console.error("Error saving project:", error);
            showResult(false);
        }).finally(() => {
            setLoading(false);
            close(); // Close the form after saving
        });
    }

    return (
        <Box component={'form'} onSubmit={handleSave} sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding:2, minWidth: '200px' }}>

            <Typography variant='h5' mt={2}>Informations de l'évènement</Typography>
            <Stack direction="row" gap={1} flex={1} flexWrap='wrap' alignItems="center">
                <TextField fullWidth variant='standard' label='Titre' value={titre} onChange={(e) => setTitre(e.target.value)} required sx={{minWidth:'200px'}} />
            </Stack>
            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth label='Organisateur' value={organisateur} onChange={(e) => setOrganisateur(e.target.value)} required sx={{minWidth:'200px'}} />
                <TextField type='date' label='Date' slotProps={{inputLabel:{ shrink: true} }} value={date} onChange={(e) => setDate(e.target.value)} required sx={{minWidth:'200px'}} />
                <TextField label='Heure' type='time' slotProps={{inputLabel:{ shrink: true} }} value={heure} onChange={(e) => setHeure(e.target.value)} required sx={{minWidth:'150px'}} />
            </Stack>

            <Stack direction="row" gap={1} alignItems="center">
                <TextField label="type d'évènement" value={type} onChange={(e) => setType(e.target.value)} required sx={{minWidth:'300px'}}/>
                <TextField fullWidth label='Lieu' value={lieu} onChange={(e) => setLieu(e.target.value)} required sx={{minWidth:'200px'}} />
            </Stack>

            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth type='date' label='Début inscriptions' slotProps={{inputLabel:{ shrink: true} }} value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} required sx={{minWidth:'100px'}} />
                <TextField fullWidth type='date' label='Fin inscriptions' slotProps={{inputLabel: {shrink: true}}} value={dateFin} onChange={(e) => setDateFin(e.target.value)} required sx={{minWidth:'100px'}} />
            </Stack>

            <TextField fullWidth multiline rows={3} label='Description' value={description} onChange={(e) => setDescription(e.target.value)} required sx={{minWidth:'200px'}} />

            <Typography variant='h5' mt={2}>Places et Objectifs</Typography>
            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth type='number' label='Nombre de places (si limitées)' value={place} onFocus={() => {if(place === 0) setPlace('')}} onBlur={() => {if(place === '') setPlace(0)}} onChange={(e) => setPlace(e.target.value)} sx={{minWidth:'200px'}} />
                <TextField fullWidth type='number' label='Objectif vente billets' value={objectifBillets} onFocus={() => {if(objectifBillets === 0) setObjectifBillets('')}} onBlur={() => {if(objectifBillets === '') setObjectifBillets(0)}} onChange={(e) => setObjectifBillets(e.target.value)} sx={{minWidth:'200px'}} />
                <TextField fullWidth type='number' label='Objectif recette (€)' value={objectifRecette} onFocus={() => {if(objectifRecette === 0) setObjectifRecette('')}} onBlur={() => {if(objectifRecette === '') setObjectifRecette(0)}} onChange={(e) => setObjectifRecette(e.target.value)} sx={{minWidth:'200px'}} />
            </Stack>

            <FormControlLabel control={<Checkbox checked={isFree} onChange={(e) => setIsFree(e.target.checked)} />} label="Évènement gratuit" />

            { !isFree &&<>
            <Typography variant='h5' mt={2}>Tarifs</Typography>
            <Stack direction='column' spacing={2} sx={{marginBottom: 2}}>
                {tarifs.map((item, index)=>
                    <Stack key={index} direction="row" gap={1} alignItems="center" sx={{alignSelf: 'center', minWidth:'200px'}}>
                        <IconButton onClick={()=>setTarifs(old=>old.length>1 ? old.filter((trf, i)=> i!==index) : [{nom:'', montant:0, description:''}])}><Delete/></IconButton>

                        <Stack direction='column' spacing={1}>
                            <Stack direction="row" gap={1} alignItems="center">
                                <TextField fullWidth label='Nom' value={item.nom} onChange={(e)=>setTarifs(prev=>{prev[index].nom = e.target.value; return [...prev]})} required sx={{minWidth:'200px'}}/>
                                <TextField type='number' label='Montant' value={item.montant} required sx={{minWidth:'100px'}}
                                onFocus={e => {if(item.montant === 0) setTarifs(prev => {prev[index].montant = ''; return [...prev]})}}
                                onChange={(e)=>setTarifs(prev=>{prev[index].montant = e.target.value; return [...prev]})} />
                            </Stack>
                            <TextField fullWidth label='Description' value={item.description} onChange={(e)=>setTarifs(prev=>{prev[index].description = e.target.value; return [...prev]})} sx={{minWidth:'200px'}}/>
                        </Stack>

                        <IconButton onClick={()=>setTarifs(old=>[...old, {nom:'', montant:0, description:''}])}><Add/></IconButton>
                    </Stack>
                )}
            </Stack>
            </>}

            <Button
                variant="outlined"
                component="label"
                sx={{ alignSelf: 'flex-start', mb: 1 }}
            >
                Importer une image d'affiche
                <input required = {!project?.image}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={async (e) => {
                        const file = e.target.files[0];
                        if (!file) return;
                        if (file.size > 5 * 1024 * 1024) {
                            alert('Le fichier est trop volumineux. Veuillez choisir un fichier de moins de 5 Mo.');
                            return;
                        }
                        setImage(file);
                    }}
                />
            </Button>
            { imageFile!=='' && <img src={project&&project.image===imageFile ? (process.env.REACT_APP_API_URL+imageFile) : URL.createObjectURL(imageFile)} width={'300px'}  />}

            <Stack direction="row" spacing={2} alignItems="center" justifyContent={'flex-end'}>
                <Button variant="outlined" onClick={close}>annuler</Button>
                <Button variant="contained" color="primary" type="submit" disabled={loading}>
                    {loading && <CircularProgress size={24} />} Enregistrer
                </Button>
            </Stack>

            <Backdrop open={loading}><CircularProgress/></Backdrop>
        </Box>
    );
}